import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Wrench, LogIn } from "lucide-react";
import { API } from "@/config";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Login mislukt");
      localStorage.setItem("mw_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0C] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="card-dark w-full max-w-sm p-8">
        <div className="flex items-center gap-2 mb-8 justify-center">
          <div className="w-9 h-9 rounded-lg bg-[#E11D48] flex items-center justify-center">
            <Wrench size={18} className="text-white" />
          </div>
          <span className="font-heading font-extrabold text-lg text-white">MILANO <span className="text-[#E11D48]">WORX</span></span>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="label-dark">E-mail</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-dark" data-testid="admin-email-input" />
          </div>
          <div>
            <label className="label-dark">Wachtwoord</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-dark" data-testid="admin-password-input" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-red w-full disabled:opacity-50" data-testid="admin-login-submit">
            <LogIn size={17} />{loading ? "..." : "Inloggen"}
          </button>
        </form>
      </div>
    </div>
  );
}
